/* eslint-disable max-len */
/* tslint:disable */
// TOTVS TypeScript translation resource
// Reference date : 20240118

export const generalRU = {
  str0001: 'Sales Portal (Protheus Line)',
  str0002: 'Load more results',
  str0003: 'My Notifications',
  str0004: 'My Sales',
  str0005: 'My Budgets',
  str0006: 'My Orders',
  str0007: 'My Customers',
  str0008: 'Sales',
  str0009: 'Budgets',
  str0010: 'Customers',
  str0011: 'Customer',
  str0012: 'Prospects',
  str0013: 'Prospect',
  str0014: 'Notifications',
  str0015: 'Orders',
  str0016: 'Order',
  str0017: 'Sales Order',
  str0018: 'Price List',
  str0019: 'Operation Type',
  str0020: 'Products',
  str0021: 'Product',
  str0022: 'Budget',
  str0023: 'Bills',
  str0024: 'Cards',
  str0025: 'Charts',
  str0026: 'Data',
  str0027: 'delivery',
  str0028: 'Loading',
  str0029: 'No data found',
  str0030: 'Enter the desired Alias',
  str0031: 'View',
  str0032: 'Show More',
  str0033: 'Authentication Error',
  str0034: 'Close',
  str0035: 'Date',
  str0036: 'Cancel Filter',
  str0037: 'List',
  str0038: 'Date not valid',
  str0039: 'Apply Filter',
  str0040: 'Notification Filter',
  str0041: 'Notification Type',
  str0042: 'Notification Status',
  str0043: 'Transaction Status',
  str0044: 'Show all notifications',
  str0045: 'Error loading notifications',
  str0046: 'Error updating notifications',
  str0047: 'Description',
  str0048: 'Home',
  str0049: 'Filter Type',
  str0050: 'Start Date',
  str0051: 'End Date',
  str0052: 'Search Time',
  str0053: 'Yearly',
  str0054: 'Monthly',
  str0055: 'Sales Indicators',
  str0056: 'Showing Indicators From',
  str0057: 'No Filter Selected',
  str0058: 'Indicators Filter',
  str0059: 'Apply Filters',
  str0060: 'Download Indicators',
  str0061: 'Details',
  str0062: 'Advanced Filter',
  str0063: 'User validation error',
  str0064: 'New Order',
  str0065: 'New Budget',
  str0066: 'Note',
  str0067: 'The system will always use the first and the last day of the selected months',
  str0068: 'Select Comparison Format between Indicators',
  str0069: 'Enter a Start and an End date to Apply the Filter (dd/mm/yyyy)',
  str0070: 'Start date cannot be later than End date.',
  str0071: 'Difference between dates cannot exceed 12 months.',
  str0072: 'Difference between dates cannot exceed 12 years.',
  str0073: `Search by customer's corporate name`,
  str0074: 'Corporate Name',
  str0075: `Search by customer's assumed name`,
  str0076: 'Assumed Name',
  str0077: `Search by customer's SSN/EIN`,
  str0078: 'SSN/EIN',
  str0079: 'Addition Date',
  str0080: 'Select customer status',
  str0081: 'Customer Status',
  str0082: 'dd/mm/yyyy',
  str0083: 'Status',
  str0084: 'Customer Details',
  str0085: 'Customer not Found',
  str0086: 'More than one customer with the same code were found',
  str0087: 'Contact the IT team',
  str0088: 'Address',
  str0089: 'Postal Code',
  str0090: 'Country',
  str0091: 'State',
  str0092: 'City',
  str0093: 'Number',
  str0094: 'Additional Address Information',
  str0095: 'Contacts',
  str0096: 'Type',
  str0097: 'Phone',
  str0098: 'No contacts saved for this customer',
  str0099: 'Could not obtain customer contacts because the customer does not have a linked SSN/EIN',
  str0100: 'Business',
  str0101: 'Business Phone Number',
  str0102: 'Home',
  str0103: 'Business Fax',
  str0104: 'Home Fax',
  str0105: 'Mobile Phone Number',
  str0106: 'Not identified',
  str0107: 'Registration Data',
  str0108: 'State Registration',
  str0109: 'City Registration',
  str0110: 'Code',
  str0111: 'Credit Limit',
  str0112: 'Credit Used',
  str0113: 'Total Credit',
  str0114: 'Credit Risk',
  str0115: `Based on customer's financial history`,
  str0116: 'Default',
  str0117: 'Of default probability',
  str0118: 'Connect to the Internet to have access.',
  str0119: 'View details',
  str0120: 'Bill',
  str0121: 'Quantity of open bills',
  str0122: 'Wait',
  str0123: 'Confirm',
  str0124: 'Edit user',
  str0125: 'WARNING: If you confirm the operation, all pending synchronizations will be ignored.',
  str0126: 'Search an order by Code, Customer or Issue Date',
  str0127: 'Order Filter',
  str0128: 'Comparison Format',
  str0129: 'Select Comparison Period',
  str0130: 'Viewed',
  str0131: 'Search by bill name, due date, issue date.',
  str0132: 'Order released for billing',
  str0133: 'Order billed',
  str0134: 'Customer activated',
  str0135: 'Order Reversed',
  str0136: 'Order Blocked by Credit',
  str0137: 'Order Blocked by Stock',
  str0138: 'Time',
  str0139: 'Order Transfer',
  str0140: 'Customer Transfer',
  str0141: 'Waiting for Viewing',
  str0142: 'Activated',
  str0143: 'Deactivated',
  str0144: 'Last Purchase',
  str0145: 'Store',
  str0146: 'Processing...',
  str0147: 'Bill Overdue',
  str0148: 'No Pendency',
  str0149: 'Financial Pendencies',
  str0150: 'View Details',
  str0151: 'Financial',
  str0152: 'Customer Filter',
  str0153: 'Customer Code',
  str0154: 'EIN',
  str0155: 'SSN',
  str0156: 'Full Name',
  str0157: 'Name',
  str0158: 'Final Cons.',
  str0159: 'Rural Producer',
  str0160: 'Dealer',
  str0161: 'Joint',
  str0162: 'Export',
  str0163: 'Customer Type',
  str0164: 'Contact Data',
  str0165: 'Email',
  str0166: 'Phone numbers',
  str0167: 'Very Low',
  str0168: 'Low',
  str0169: 'Medium',
  str0170: 'High',
  str0171: 'Very High',
  str0172: 'Available credit',
  str0173: 'Open',
  str0174: 'Overdue',
  str0175: 'Paid',
  str0176: 'Bill Number',
  str0177: 'Value',
  str0178: 'Due Date',
  str0179: 'Prefix',
  str0180: 'Branch',
  str0181: 'Installment',
  str0182: 'Issue',
  str0183: 'Settled Vl.',
  str0184: 'Open Balance',
  str0185: 'Partial Post.',
  str0186: `WARNING: THE ORDER TOTAL PRESENTED AS "Value" REFERS TO THE ITEMS' GROSS VALUE.`,
  str0187: 'Order Code',
  str0188: 'Rule B.',
  str0189: 'Funds B.',
  str0190: 'Closed',
  str0191: 'Released',
  str0192: 'Blocked by Rule',
  str0193: 'Blocked by Funds',
  str0194: 'Order not synchronized',
  str0195: 'Some order information may change after synchronization. Continue generating PDF?',
  str0196: 'Continue',
  str0197: 'Not synchronized',
  str0198: 'Error',
  str0199: 'Online',
  str0200: 'Enter the full date.',
  str0201: 'Order Status',
  str0202: 'Search by Name or Customer code',
  str0203: 'Search by Name or Prospect/Customer Code',
  str0204: 'Search by Code or Product Description',
  str0205: 'Working offline',
  str0206: 'Work offline',
  str0207: 'Back to my orders',
  str0208: 'Edit order',
  str0209: 'Delete order',
  str0210: 'Order details',
  str0211: 'Generate PDF',
  str0212: 'Summary download',
  str0213: 'Order not found',
  str0214: 'More than one customer with the same code were found',
  str0215: 'Sales Rep',
  str0216: 'Release by Item',
  str0217: 'Release by Order',
  str0218: 'On third parties',
  str0219: 'On the sender',
  str0220: 'On the recipient',
  str0221: 'No shipping',
  str0222: 'CIF',
  str0223: 'FOB',
  str0224: 'Not specified',
  str0225: 'Delivery and Payment',
  str0226: 'Release Type',
  str0227: 'Freight Type',
  str0228: 'Fleet Operator',
  str0229: 'Delivery Address',
  str0230: 'Payment Term',
  str0231: 'Customer Information',
  str0232: 'Billing Address',
  str0233: 'Order Total',
  str0234: 'Sub-total',
  str0235: 'Taxes',
  str0236: 'Shipping',
  str0237: 'Insurance',
  str0238: 'Expenses',
  str0239: 'Discounts',
  str0240: 'Discount',
  str0241: 'No',
  str0242: 'Item',
  str0243: 'Items',
  str0244: 'Quantity',
  str0245: 'Unit Price',
  str0246: 'Total',
  str0247: 'General Information',
  str0248: 'Search by Code or Product Description',
  str0249: 'Start Order',
  str0250: 'Start budget',
  str0251: 'Cancel',
  str0252: 'Order Items',
  str0253: 'Budget Items',
  str0254: 'General Data',
  str0255: 'View customer details',
  str0256: 'Order sub-total',
  str0257: 'Items amount',
  str0258: 'Cancel order',
  str0259: 'Cancel edit',
  str0260: 'Are you sure you want to cancel the order edit?',
  str0261: 'Are you sure you want to cancel the new order?',
  str0262: 'Next step',
  str0263: 'Items Amt.',
  str0264: 'Items Visibility',
  str0265: 'Select a price list to view the items and their details.',
  str0266: 'Comments',
  str0267: 'Credit limit available',
  str0268: 'Items cumulative discount',
  str0269: 'Select a price list',
  str0270: 'All items in the list',
  str0271: 'Only order items',
  str0272: 'Select payment method',
  str0273: 'Select carrier',
  str0274: 'Select shipping type',
  str0275: 'Enter insurance number',
  str0276: 'Enter expense amount',
  str0277: 'Order general information',
  str0278: 'Delivery information',
  str0279: 'Enter shipping value',
  str0280: 'Select release type',
  str0281: ' Order Type',
  str0282: 'Currency',
  str0283: 'Partial',
  str0284: 'In portfolio',
  str0285: 'Percentage',
  str0286: 'Value in currency',
  str0287: 'Discount in product',
  str0288: 'List price',
  str0289: 'Unit price entered',
  str0290: 'Product total price',
  str0291: 'Discount in',
  str0292: 'Percentage discount',
  str0293: 'Only numbers',
  str0294: 'Discount Value',
  str0295: 'Value with discount',
  str0296: 'Margin with discount',
  str0297: 'Cancel discount',
  str0298: 'Apply discount',
  str0299: 'Could not generate PDF. Try again.',
  str0300: 'Search product by Code or Description',
  str0301: 'Order comments',
  str0302: 'The customer will not be able to see the notes added.',
  str0303: 'Total Value',
  str0304: 'Add Discount',
  str0305: 'Search Products',
  str0306: 'Selected products',
  str0307: 'Showing',
  str0308: 'of',
  str0309: 'found',
  str0310: 'found',
  str0311: `Add order comments. Example: Deliver in the afternoon, request operation manager's signature...`,
  str0312: 'Inactive Price List',
  str0313: 'Price list out of validity',
  str0314: 'Product prices out of validity',
  str0315: 'Selected product',
  str0316: 'No product selected',
  str0317: 'Order Summary',
  str0318: 'Error returning payment term',
  str0319: 'Synchronization pending',
  str0320: 'Unit Prc.',
  str0321: 'List Prc.',
  str0322: 'Total',
  str0323: 'Inflow Qty',
  str0324: 'Tax value will only be calculated after order synchronization.',
  str0325: 'Payment term invalid for this price list',
  str0326: 'Add',
  str0327: '+ Information',
  str0328: 'Select the Operation Type',
  str0329: 'Enter a customer or prospect to start the Budget',
  str0330: 'Enter a customer to start the Order',
  str0331: 'Edit Order',
  str0332: 'Failed to add Sales Order',
  str0333: 'Order sent for synchronization.',
  str0334: 'Error sending JSON',
  str0335: 'Error sending Order for synchronization',
  str0336: 'Order Active',
  str0337: 'Order integration failure',
  str0338: 'Show order details',
  str0339: 'Failed to delete sales order',
  str0340: 'Confirm Deletion',
  str0341: 'Do you really want to delete the Order?',
  str0342: 'Invalid Status',
  str0343: 'Cannot delete a Sales Order with Status Released, Closed or Not Synchronized.',
  str0344: 'Order added',
  str0345: 'Order edited',
  str0346: 'Order deleted',
  str0347: 'Exit',
  str0348: 'Are you sure you want to exit?',
  str0349: 'Orders pending synchronization will be canceled if you exit.',
  str0350: 'The order total value can vary according to your Internet connection, because taxes are only calculated when you are online.',
  str0351: 'Error when calculating taxes',
  str0352: 'Try again later.',
  str0353: 'Calculating totals',
  str0354: 'Failed to save access log',
  str0355: 'Your section has expired',
  str0356: 'You will need to log in again to synchronize your edits. \nDo you want to log in now? Otherwise, the system will stay in offline mode.',
  str0357: 'Failed to return Operation Types',
  str0358: 'Back to My Budgets',
  str0359: 'Budget Details',
  str0360: 'Failed to load budget',
  str0361: 'Failed to load customer',
  str0362: 'More information',
  str0363: 'Prospect Information',
  str0364: 'Prospect Code',
  str0365: 'Failed to load prospect',
  str0366: 'Search a Budget by Code, Prospect/Customer Code or Issue Date',
  str0367: 'Select order status',
  str0368: 'Open',
  str0369: 'Posted',
  str0370: 'Canceled',
  str0371: 'Not Budgeted',
  str0372: 'Blocked',
  str0373: 'Issue Date',
  str0374: 'Failed to return product search.',
  str0375: 'Budget Status',
  str0376: 'Budget Filter',
  str0377: 'Customer or Prospect',
  str0378: 'Budget Code',
  str0379: 'Search a customer by Code, Name or CGC',
  str0380: 'Search a Prospect by Code, Name or CGC',
  str0381: 'Budget added',
  str0382: 'Budget edited',
  str0383: 'Budget deleted',
  str0384: 'Search customer by code, assumed name or EIN/SSN',
  str0385: 'Select notification type',
  str0386: 'Select notification status',
  str0387: 'Select transaction status',
  str0388: 'Select budget status',
  str0389: 'Search a notification by Title or Description',
  str0390: 'Error loading Budgets',
  str0391: 'Error returning Notifications',
  str0392: 'Error Returning Customers',
  str0393: 'Error Returning Orders',
  str0394: 'Error Returning Products',
  str0395: 'Error Returning Bills',
  str0396: 'Error returning Sellers',
  str0397: 'Failed to Update Unit Price',
  str0398: 'Failed to load Price List item',
  str0399: 'Could not find the product entered',
  str0400: 'Loading delivery data...',
  str0401: 'Loading order data...',
  str0402: 'Loading Cards and Charts',
  str0403: 'Error querying arrears',
  str0404: 'Select Budget status',
  str0405: 'Edit budget',
  str0406: 'Delete budget',
  str0407: 'New Budget',
  str0408: 'Start budget',
  str0409: 'Budget Items',
  str0410: 'Save',
  str0411: 'Budget subtotal',
  str0412: 'Budget Total',
  str0413: 'Cancel budget',
  str0414: 'Cancel budget edit?',
  str0415: 'Cancel new budget?',
  str0416: 'Budget items only',
  str0417: 'Budget general information',
  str0418: 'Budget type',
  str0419: 'Budget summary',
  str0420: 'Edit budget',
  str0421: 'Error when adding budget.',
  str0422: 'Budget sent for synchronization.',
  str0423: 'Budget activated',
  str0424: 'Failed to integrate Budget',
  str0425: 'Show budget details',
  str0426: 'Delete this Budget?',
  str0427: 'Cannot delete a budget with status Posted, Not Synchronized, or with a Business Proposal linked to it.',
  str0428: 'Loading budget data...',
  str0429: 'Budget',
  str0430: 'Budget details',
  str0431: 'Failed to load budget',
  str0432: 'My Budgets',
  str0433: 'Budgets',
  str0434: 'Search a budget by Code, Customer/Prospect Code or Issue Date',
  str0435: 'Loading budgets',
  str0436: 'Error loading Budgets',
  str0437: 'Open',
  str0438: 'Posted',
  str0439: 'Canceled',
  str0440: 'Not Budgeted',
  str0441: 'Blocked',
  str0442: 'Number',
  str0443: 'Issue Date',
  str0444: 'Failed to return product search.',
  str0445: 'Budget Status',
  str0446: 'Budget Filter',
  str0447: 'Customer or Prospect',
  str0448: 'Budget Code',
  str0449: 'Search a Prospect by Code, Name or CGC',
  str0450: 'Budget added',
  str0451: 'Budget edited',
  str0452: 'Budget deleted',
  str0453: 'Budget Transaction',
  str0454: 'Search a customer by Code, Name or CGC',
  str0455: 'Back to My Budgets',
  str0456: 'Show budget details',
  str0457: 'Budget not synchronized',
  str0458: 'Some budget information may change after synchronization. Proceed with PDF generation?',
  str0459: 'Budget cannot be deleted because it is linked to a business proposal.',
  str0460: 'Customized Fields',
  str0461: 'Failed to delete budget',
  str0462: 'Error returning budgets',
  str0463: 'Invalid value',
  str0464: 'Save order',
  str0465: `The budget's total value may vary according to your Internet connection because taxes are calculated only if you are online.`,
  str0466: 'Error sending budget for synchronization',
  str0467: 'Financial Data',
  str0468: 'Synchronizing',
  str0469: 'Billing (Amount)',
  str0470: 'Does not Apply',
  str0471: 'On-site',
  str0472: 'Operation not on-site, by Internet',
  str0473: 'Not on-site, phone service',
  str0474: 'On-site, out of premises',
  str0475: 'Not on-site, others',
  str0476: 'Mediator Code',
  str0477: 'Purchaser Presence',
  str0478: 'Financial Mediator',
  str0479: 'Failed to get financial mediators',
  str0480: 'Select the financial mediator',
  str0481: 'Select the presence indicator',
  str0482: 'Synchronism interrupted, click X in the menu above to restart',
  str0483: 'Synchronization error.',
  str0484: 'Could not perform the initial load of data. Click here to try again.',
  str0485: 'Return',
  str0486: 'Calculating...',
  str0487: 'Enter your user',
  str0488: 'Enter your password',
  str0489: 'Failure obtaining List of Fields',
  str0490: 'This contact has no telephones.',
  str0491: 'This customer does not have a credit limit entry.',
  str0492: 'This field does not accept special characters.',
  str0493: 'Order successfully added.',
  str0494: 'Order successfully edited.',
  str0495: 'Error when editing Sales Order.',
  str0496: 'Order successfully deleted.',
  str0497: 'Error when calculating total:',
  str0498: 'contains',
  str0499: 'Deleting order...',
  str0500: `Schemas required to use TGV not found. Check whether function SETUPTGV was executed in accordance with documentation: <a href='https://tdn.totvs.com/pages/releaseview.action?pageId=579468339#TOTVSGest%C3%A3odeVendas:GuiadeReferencia-CONFIG_PILOTO'target='_blank'> TGV - Guia de Referкncia </a>`,
  str0501: 'Products Quantity',
  str0502: 'Products Qty',
  str0503: 'Access Denied',
  str0504: 'User has no link with a Sales Rep!',
  str0505: 'User has no access to sensitive or personal data',
  str0506: 'Schema Error',
  str0507: 'Error when returning Sales Order',
  str0508: 'Failed to return the schemas. Check tables A1V and A1W.',
  str0509: 'Loading Order items...',
  str0510: 'Regular',
  str0511: 'Price/Quantity Complement',
  str0512: 'ICMS Complement',
  str0513: 'IPI Complement',
  str0514: 'Purchases Return',
  str0515: 'Use Supplier',
  str0516: 'Error when getting Order item',
  str0517: 'Error when returning options for Order Type',
  str0518: 'Error when returning country',
  str0519: 'Enter group code or click the magnifying glass to search for it',
  str0520: 'Enter branch code or click the magnifying glass to search for it',
  str0521: 'Group',
  str0522: 'Change Branch',
  str0523: 'ATTENTION: the branch selected is the same as the current one. Select a different branch.',
  str0524: 'Enter',
  str0525: 'ATTENTION',
  str0526: 'Session expired. To continue, login again.',
  str0527: 'Querying bills',
  str0528: 'Sales Portal',
  str0529: 'Loading Customer information...',
  str0530: 'Error checking sales representative',
  str0531: 'Failure getting financial information',
  str0532: 'You can update your version by downloading the continuous dispatch package, click <a href="https://tdn.totvs.com/pages/releaseview.action?pageId=521997859" target="_blank">HERE</a>.',
  str0533: 'Outdated PGV version',
  str0534: 'New version available. Refresh the page?',
  str0535: 'Error in attempt to filter Sales Budget',
  str0536: 'Message',
  str0537: 'Checking Prospect name',
  str0538: 'Checking Customer name',
  str0539: 'Error checking Prospect name',
  str0540: 'Error checking Customer name',
  str0541: 'Unable to register sales representative',
  str0542: 'Failed to load budget items',
  str0543: 'Budget successfully deleted.',
  str0544: 'Deleting budget...',
  str0545: 'Yes',
  str0546: 'Prospect Type',
  str0547: 'Budget successfully added.',
  str0548: 'Budget successfully edited.',
  str0549: 'You cannot edit a budget with status Posted, Canceled, Not Synced or that has a linked Business Proposal.',
  str0550: 'Error when editing budget.',
  str0551: 'Invoice message',
  str0552: 'Add notes relevant to this sales order.',
  str0553: 'The message defined will be printed on the invoice.',
  str0554: 'Add a message to be used in the invoice. For example: To be delivered in the afternoon.',
  str0555: 'Sync data',
  str0556: 'Syncing complete',
  str0557: 'Syncing data. Please wait...',
  str0558: 'Failed to return access permissions of the user',
  str0559: 'You have no access to this page',
  str0560: 'Contact the system administrator',
  str0561: 'Return to start',
  str0562: 'Filter by price list',
  str0563: 'Failed to query parameter MV_PGVCSLD',
  str0564: 'Oops, something went wrong',
  str0565: 'Check Stock',
  str0566: 'Warehouse',
  str0567: 'Current Balance',
  str0568: 'Sales Order Qty.',
  str0569: 'Allocated Qty.',
  str0570: 'Expected Incoming Qty.',
  str0571: 'Failed to check Product Balance',
  str0572: 'Other information',
  str0573: 'Customer order',
  str0574: 'Customer order number',
  str0575: 'Failed to query Schema',
  str0576: 'My Offline Configurations',
  str0577: 'Offline Configurations',
  str0578: 'Edit',
  str0579: 'Search a Schema by Code or Description',
  str0580: 'Failed to filter Schemas',
  str0581: 'Back to my settings',
  str0582: 'Edit my settings',
  str0583: 'Next',
  str0584: 'Edit settings from',
  str0585: 'Quick filter',
  str0586: 'Select records',
  str0587: 'No item added to the Sales Order',
  str0588: 'No item added to the Sales Budget',
  str0589: 'Customers that bought on:',
  str0590: 'Enabled',
  str0591: 'Disabled',
  str0592: 'Equal to',
  str0593: 'With the expression',
  str0594: 'Type of search',
  str0595: 'Select the type of search desired',
  str0596: 'Last three months',
  str0597: 'Select only the best-selling products by the sales representative in the last three months.',
  str0598: 'Stock balance',
  str0599: 'Enter the code of the products separated by comma',
  str0600: 'Enter the product description separated by comma',
  str0601: 'Enter the type of product separated by comma E.g.: PA, MP',
  str0602: 'Enter the price list code separated by comma',
  str0603: 'Select only the products with stock balance.',
  str0604: 'Description of Product 1, Description of Product 2',
  str0605: '000001,000002,000003,000004',
  str0606: 'Table 1, Table 2',
  str0607: 'Last month',
  str0608: 'Select only Customers who bought in the last month.',
  str0609: 'Select only Customers who bought in the last three months.',
  str0610: 'New Customers',
  str0611: 'Select Customers registered in the last month.',
  str0612: 'Did not buy in the last month',
  str0613: 'Select Customers who did not buy in the last month.',
  str0614: `Enter the Customers' codes separated by comma`,
  str0615: 'Trade Name',
  str0616: 'Enter the Trade Name separated by comma.',
  str0617: 'Joгo da Silva,Maria Lima,Josй de Souza',
  str0618: 'Enter the SSN or EIN of the Customers separated by comma.',
  str0619: '00.000.000/0000-00',
  str0620: 'PA, MP',
  str0621: 'Empty',
  str0622: 'This page is not available to be used offline',
  str0623: 'Offline',
  str0624: 'Selected',
  str0625: 'Filter records by:',
  str0626: 'No data selected',
  str0627: 'Error when querying Credit Limit. Please, update the backend server with the latest continuous dispatch package of Billing.',
  str0628: 'Select/Deselect',
  str0629: 'Select all',
  str0630: 'External No.',
  str0631: 'Code',
  str0632: 'Asset',
  str0633: 'Warehouse',
  str0634: 'Measurement Unit',
  str0635: 'Filter successfully deleted.',
  str0636: 'Filter deleted successfully.',
  str0637: 'Failed to register filter.',
  str0638: 'Failed to delete filter.',
  str0639: 'Perform data load ?',
  str0640: 'Perform data load',
  str0641: 'Oops! The limit of',
  str0642: 'items was reached',
  str0643: 'Item already fully or partially billed. To delete it, delete the corresponding Invoice.',
  str0644: 'This page will be available soon',
  str0645: 'We are synchronizing data, wait...',
  str0646: 'Alias not found',
  str0647: 'Source',
  str0648: 'User not authenticated - Check if it is blocked or if the user is registered in Protheus.',
  str0649: 'Your user is not linked to a vendor. To adjust this, attribute it according to the documentation <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=649301318" target="_blank"> by clicking here </a>',
  str0650: 'Oops! Could not access the user.',
  str0651: 'Failed to query transport companies',
  str0652: 'Registr.Dt.',
  str0653: 'Connection Limit Exceeded',
  str0654: 'Page not found.',
  str0655: 'The page that you are looking for does not exist.',
  str0656: 'Select only Prospects with pending budgets in the last month.',
  str0657: 'Select only Prospects with pending budgets in the last three months.',
  str0658: 'Select Prospects registered in the last month.',
  str0659: 'Select Prospects without sales budgets in the last three months.',
  str0660: `Enter the Prospects' codes separated by comma.`,
  str0661: 'Enter the SSN or EIN of the Prospects, separated by comma.',
  str0662: 'New Prospects',
  str0663: 'Did not buy in the last three months',
  str0664: `Could not update the customer's financial data`,
  str0665: 'New Customer',
  str0666: 'Start Register',
  str0667: 'Select a customer to start the register',
  str0668: 'Person Type',
  str0669: 'Add new store?',
  str0670: 'Natural Person',
  str0671: 'Legal Entity',
  str0672: 'Error while querying Person Type of Customer',
  str0673: 'Select the preferences below to register a new customer.',
  str0674: 'Unable to get the default operation type',
  str0675: 'Unable to get parameter data',
  str0676: 'Oops, your company and branch were not found in TOTVS Mingle',
  str0677: 'Company/Branch not found',
  str0678: 'Contact TOTVS Mingle support to fix the Alias record',
  str0679: 'Invalid Document',
  str0680: 'Enter the company name or full name',
  str0681: 'Enter your name or trade name',
  str0682: 'Enter the state registration no.',
  str0683: 'Enter the city registration no.',
  str0684: 'Select the type',
  str0685: 'Type',
  str0686: 'Loading options...',
  str0687: 'Enter the code',
  str0688: 'We suggested an identification code, but you can change it.',
  str0689: 'Enter the address complement',
  str0690: 'Type of person',
  str0691: 'Select type of person',
  str0692: 'Enter only numbers',
  str0693: 'Select the state',
  str0694: 'Select the city/municipality',
  str0695: 'Enter the address',
  str0696: 'District',
  str0697: 'Enter the district',
  str0698: 'Contact name',
  str0699: 'Enter the contact name',
  str0700: `Enter the contact's e-mail`,
  str0701: 'Enter a valid email',
  str0702: 'Only numbers',
  str0703: 'Document',
  str0704: 'Customers Register',
  str0705: 'Identification',
  str0706: 'Core Version',
  str0707: 'Customized Fields',
  str0708: 'No data to display',
  str0709: 'Delete',
  str0710: 'Edit Customer',
  str0711: 'Customer added successfully.',
  str0712: 'Customer edited successfully.',
  str0713: 'Customer deleted successfully.',
  str0714: 'Failed to add Customer.',
  str0715: 'Failed to Edit Customer.',
  str0716: 'Failed to Delete Customer.',
  str0717: 'Delete this Customer',
  str0718: 'The security key is disabled.',
  str0719: `The lib version is not compatible with the PGV. Update Protheus' lib.`,
  str0720: 'Notice: code and store already registered!',
  str0721: 'Could not verify the security key: Update the backend version, log out, then log in.',
  str0722: 'My Prospects',
  str0723: 'Search Prospect by code, trade name, or EIN/SSN',
  str0724: 'Classified',
  str0725: 'Development',
  str0726: 'Manager',
  str0727: 'StandBy',
  str0728: 'Disqualified',
  str0729: 'Failed to load Prospects',
  str0730: 'Current Status',
  str0731: 'Oops... The payment term selected automatically',
  str0732: `cannot be used for this sale experience. Contact your company's IT specialist.`,
  str0733: 'Oops... the price list automatically selected',
  str0734: 'Customer added',
  str0735: 'Customer edited',
  str0736: 'Customer deleted',
  str0737: 'Failed to integrate Customer',
  str0738: 'Search by the corporate name of the prospect',
  str0739: 'Search by the trade name of the prospect',
  str0740: 'Search by the SSN/EIN of the prospect',
  str0741: 'Select the prospect status',
  str0742: 'Select the prospect classification',
  str0743: 'Prospect Status',
  str0744: 'Prospect Classification',
  str0745: 'Prospect Filter',
  str0746: 'Enter the city/municipality',
  str0747: 'Failed to load the form fields initializer',
  str0748: 'New Prospect',
  str0749: 'Edit Prospect',
  str0750: 'Prospects File',
  str0751: 'Delete this Prospect?',
  str0752: 'Prospect added successfully.',
  str0753: 'Prospect edited successfully.',
  str0754: 'Prospect deleted successfully.',
  str0755: 'Failed to delete Prospect.',
  str0756: 'Failed to integrate Prospect.',
  str0757: 'Update of Link to Access',
  str0758: 'For a better experience in the Sales Management Portal, we are updating the access link to a TOTVS account on AWS. Therefore, we need you to access up to December 7 using the new link. If you are accessing from a tablet or mobile phone, you will need to create a new shortcut in your Home screen.',
  str0759: 'Prospect Details',
  str0760: 'Area Code',
  str0761: 'State',
  str0762: 'CLICK HERE',
  str0763: 'Select the following preferences to register a new Prospect.',
  str0764: 'My Contacts',
  str0765: 'Search by the code, name, or SSN/EIN',
  str0766: 'Delete this Contact Person?',
  str0767: 'Contact Person successfully deleted.',
  str0768: 'Failed to load Contact Persons',
  str0769: 'Failed to delete Contact Person.',
  str0770: 'Contact Persons File',
  str0771: 'CrtCd',
  str0772: 'Edit contract person',
  str0773: 'New contact person',
  str0774: 'Contact Person successfully edited.',
  str0775: 'Contact Person successfully added.',
  str0776: 'Failed to integrate Contact Person',
  str0777: 'Delete this Contact Person?',
  str0778: 'Contact Person successfully deleted.',
  str0779: 'Failed to delete Contact Person.',
  str0780: 'Business',
  str0781: 'Home',
  str0782: 'Business Fax',
  str0783: 'Home Fax',
  str0784: 'Mobile Phone',
  str0785: 'Contact Details',
  str0786: 'Phone and Address Data',
  str0787: 'Sales Orders Total',
  str0788: 'Number of Orders',
  str0789: 'Last update:',
  str0790: 'Total Pending Sales Orders',
  str0791: 'Total Blocked Sales Orders',
  str0792: 'Total Closed Sales Orders',
  str0793: 'My Sales Goals',
  str0794: 'My Goals',
  str0795: 'Sales Goals',
  str0796: 'Quantity Released',
  str0797: 'Invoice',
  str0798: 'Series',
  str0799: 'Customer code',
  str0800: 'Error Fetching Order List',
  str0801: 'Link Contacts',
  str0802: 'No order found:',
  str0803: 'Error fetching the sales rep. sales goal:',
  str0804: 'Gross Value:',
  str0805: 'Net Value:',
  str0806: 'Returned Value:',
  str0807: 'Monthly Goal',
  str0808: 'Data successfully registered !',
  str0809: 'Failed to register data.',
  str0810: 'Delivery Date',
  str0811: 'Error fetching data from the last 7 days in the sales chart.',
  str0812: 'Best-Selling Products - Monthly',
  str0813: 'Revenue of the last 7 days',
  str0814: 'Gross Val.',
  str0815: 'Net Val.',
  str0816: 'Returned Val.',
  str0817: 'No. of Sales',
  str0818: 'Accounting value',
  str0819: 'Asset value',
  str0820: 'Total Embedded Taxes',
  str0821: 'Total Non-levying Taxes',
  str0822: 'Total Tax Value',
  str0823: 'Duplicated Base',
  str0824: 'Ancillary Expenses',
  str0825: 'Tax',
  str0826: 'Calculation Base',
  str0827: 'Rate',
  str0828: 'Product Code',
  str0829: 'ST Value',
  str0830: 'CSLL Value',
  str0831: 'Unit Value',
  str0832: 'PIS Rate',
  str0833: 'IPI Rate',
  str0834: 'PIS Value',
  str0835: 'Calculation PIS Value',
  str0836: 'ST PIS Value',
  str0837: 'COFINS Rate',
  str0838: 'COFINS Value',
  str0839: 'Calculation COFINS Value',
  str0840: 'ST Rate',
  str0841: 'CSLL Rate',
  str0842: 'ICMS Value',
  str0843: 'IPI Value',
  str0844: 'TIO',
  str0845: 'Financial Sheet',
  str0846: 'Total',
  str0847: 'Order Invoices:',
  str0848: 'Could not load the invoices',
  str0849: 'Invoices',
  str0850: 'No invoices exist linked to this Sales Order',
  str0851: 'Invoice',
  str0852: 'Invoice Type',
  str0853: 'Invoice Key',
  str0854: 'Invoice Series',
  str0855: 'Electronic Key Invoice',
  str0856: 'NF access data',
  str0857: 'There is no registered URL for this municipality.',
  str0858: 'Unable to view invoice',
  str0859: 'Access Invoice',
  str0860: 'Access key',
  str0861: `Dear customer, you will be redirected to the city hall's website. To download the Service Invoice, you will need to fill in the requested information.`,
  str0862: 'Customize PDF',
  str0863: 'Image URL',
  str0864: 'Select Customization Type',
  str0865: 'Type of PDF',
  str0866: 'New Custom PDF',
  str0867: 'My PDF Settings',
  str0868: 'Edit PDF',
  str0869: 'New PDF',
  str0870: 'PDF successfully edited',
  str0871: 'PDF successfully added',
  str0872: 'Error when adding PDF',
  str0873: 'Sections',
  str0874: 'Fields',
  str0875: 'Section Code',
  str0876: 'Section Title',
  str0877: 'Section Description',
  str0878: 'Select the Section',
  str0879: 'Select the Fields',
  str0880: 'Header',
  str0881: 'Property',
  str0882: 'Format',
  str0883: 'Decimal',
  str0884: 'Thousands Separator',
  str0885: 'Move up',
  str0886: 'Move down',
  str0887: 'Add field',
  str0888: 'Edit field',
  str0889: 'Character',
  str0890: 'Numeric',
  str0891: 'Logical',
  str0892: 'Confirm section deletion',
  str0893: 'Delete this section? Deleting it also deletes the fields.',
  str0894: 'Confirm',
  str0895: 'Confirm field deletion',
  str0896: 'Delete this field?',
  str0897: 'Enter all required data prior to confirming deletion.',
  str0898: 'Some required fields in PDF settings have not been filled in.',
  str0899: 'Some required fields in one of the sections of PDF settings have not been filled in.',
  str0900: 'One of the sections of PDF settings does not have entered fields.',
  str0901: 'No section of PDF settings was entered. This is required to save the database configuration.',
  str0902: 'Error when loading PDF Settings',
  str0903: 'Confirm Deletion of PDF Setting',
  str0904: 'Do you really want to delete this PDF Setting?',
  str0905: 'Search by code, title or description of PDF setting.',
  str0906: 'View PDF',
  str0907: 'PDF selection',
  str0908: 'Choose PDF template',
  str0909: 'Standard Model',
  str0910: 'You cannot add more than one Items section',
  str0911: 'Custom',
  str0912: 'It is not possible to include more than 7 fields in Sections of type Items',
  str0913: 'My Products',
  str0914: 'Product Photo',
  str0915: 'Confirm',
  str0916: 'Budget Confirmation',
  str0917: 'Do you want to continue the budget confirmation',
  str0918: 'Cancel',
  str0919: 'Price Quote Cancellation',
  str0920: 'Do you want to continue the budget cancellation',
  str0921: 'Error when confirming budget.',
  str0922: 'Error when canceling budget.',
  str0923: 'My Commissions',
  str0924: 'Commissions',
  str0925: 'The image URL is invalid or blocked by CORS. Contact your IT department or provide a valid URL.',
  str0926: 'Consult',
  str0927: 'Export xlsx',
  str0928: 'Unable to load report data',
  str0929: 'Check that all fields have been filled in correctly before performing the query',
  str0930: 'The date in the "To Date?" field must be later than the date in the "From Date?" field and the interval between the two cannot exceed 1 year.',
  str0931: 'Return to my commissions',
  str0932: 'No records found with the values ​​provided',
  str0933: 'Default Logo',
  str0934: 'Default Logo PDF changed successfully',
  str0935: 'Update the PGV backend version as per the link below, then perform a logout and login.',
  str0936: 'Contact successfully linked',
  str0937: 'Failure to add/edit contact'
};
